<template>
  <v-card class="mb-5" rounded="lg">
    <v-card-title class="text-caption font-weight-bold">Búsqueda Avanzada</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="filterByColumns(columns)">
        <v-row :class="{'justify-center': $vuetify.breakpoint.xs}" dense>
          <!-- Campos de filtro normales -->
          <v-col v-for="column in columns" :key="column.name" cols="12" sm="6" lg="4" md="4" class="margin-bottom" >
            <template v-if="column.type == 'select'">
              <v-select v-model="column.value" :items="column.options" :disabled="column.disabled" item-text="name" item-value="value"
                outlined dense :label="column.title" hide-details="auto" @change="handleChange(column.onChange)" />
            </template>
            <template v-else-if="column.type == 'dynamic-select'">
              <div class="dynamic-select-wrapper">
                <v-select
                  v-model="column.value"
                  :items="getDynamicSelectItems(column)"
                  :disabled="isDynamicSelectDisabled(column)" item-text="name" item-value="value"
                  outlined dense :label="column.title" hide-details="auto" @change="handleChange(column.onChange)" />
                <button
                  v-if="isDynamicSelectDisabled(column) && column.disabledMessage"
                  type="button"
                  class="dynamic-select-disabled-overlay"
                  :aria-label="column.disabledMessage"
                  @click="showDynamicSelectDisabledMessage(column)"
                ></button>
                <div
                  v-if="isDynamicSelectDisabled(column) && dynamicSelectDisabledMessages[column.name]"
                  class="dynamic-select-disabled-message"
                >
                  {{ column.disabledMessage }}
                </div>
                <div
                  v-if="!isDynamicSelectDisabled(column) && column.enabledMessage"
                  class="dynamic-select-enabled-message"
                >
                  {{ column.enabledMessage }}
                </div>
              </div>
            </template>
            <template v-else-if="column.type == 'date'" >
              <date-picker v-model="column.value" :value="column.value" :label="column.title" ></date-picker>
            </template>
            <template v-else-if="column.type === 'between'">
              <div class="d-flex justify-space-between align-center">
                <date-picker v-model="column.from.value" :value="column.from.value" :label="column.from.title"></date-picker>
                <date-picker v-model="column.to.value" :value="column.to.value" :label="column.to.title" ></date-picker>
              </div>
            </template>
            <template v-else-if="column.type === 'number'">
              <v-text-field v-model="column.value" type="number" :label="column.title" outlined hide-details="auto" 
                :rules="[v => /^\d+$/.test(v) || 'Solo se permiten números']" inputmode="numeric" @keypress="soloNumeros"
                dense></v-text-field>
            </template>
            <template v-else-if="column.type == 'checkbox'">
                <v-checkbox  
                    :key="column.title"
                    v-model="column.value"  
                    @change="filterOptions(column)" 
                    :label="column.title"/>
            </template>
            <template v-else>
              <v-text-field v-model="column.value" :label="column.title" outlined hide-details="auto"
                dense></v-text-field>
            </template>
          </v-col>
          
          <!-- Selector de Sucursal al final, antes de los botones -->
          <v-col v-if="showBranchSelector && ( $store.getters['rolesUser/getCustomRole'](2) || $store.getters['rolesUser/getCustomRole'](267) || this.$store.getters['rolesUser/getArrayCustomRole']([277]))" cols="12" sm="6" lg="4" class="margin-bottom">
            <v-select 
              :value="selectedBranch"
              @input="onBranchChange"
              :items="branches"
              item-text="BranchName"
              item-value="ID_Branch"
              label="Sucursal"
              :hint="currentBranch ? `${currentBranch}` : ''"
              persistent-hint
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>

          <!-- Checkbox para mostrar todos los registros -->
          <v-col v-if="showAllRecordsToggle" cols="12" sm="6" lg="4" class="margin-bottom">
            <v-checkbox
              v-model="localShowAllRecords"
              @change="onShowAllRecordsChange"
              label="Mostrar todos los registros (sin límite de 100)"
              dense
              hide-details="auto"
            />
          </v-col>
          
          <!-- advanced filter buttons -->
          <v-col cols="6" sm="3" lg="2">
            <v-btn type="submit" color="primary" block>
              <v-icon class="mr-2">mdi-filter</v-icon>
              Filtrar
            </v-btn>
          </v-col>
          <v-col cols="6" sm="3" lg="2">
            <v-btn @click="$emit('onClean')" color="warning" block>
              <v-icon class="mr-2">mdi-backspace-outline</v-icon>
              Limpiar
            </v-btn>
          </v-col>
          <v-col cols="12" v-if="$slots.complementFilters">            
            <slot name="complementFilters"></slot>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import DatePicker from '@/components/DatePicker2'
export default {
  name: 'GeneralFilterForm',
  components: {
    DatePicker
  },
  data() {
    return {
      localShowAllRecords: false,
      dynamicSelectDisabledMessages: {}
    }
  },
  props: {
    columns: {
      type: Array,
      default: null
    },
    showBranchSelector: {
      type: Boolean,
      default: false
    },
    selectedBranch: {
      type: [String, Number],
      default: null
    },
    branches: {
      type: Array,
      default: () => []
    },
    currentBranch: {
      type: String,
      default: ''
    },
    showAllRecords: {
      type: Boolean,
      default: false
    }
    ,
    // Controla si se muestra el checkbox "Mostrar todos los registros"
    showAllRecordsToggle: {
      type: Boolean,
      default: false
    },
    alternativeColumnsFilterStyle: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showAllRecords: {
      immediate: true,
      handler(newVal) {
        this.localShowAllRecords = newVal
      }
    }
  },
  methods: {
    filterByColumns() {
      this.$emit('onFilter')
    },
    onBranchChange(value) {
      this.$emit('onBranchChange', value)
    },
    onShowAllRecordsChange() {
      this.$emit('onShowAllRecordsChange', this.localShowAllRecords)
    },
    soloNumeros(e) {
      const key = e.keyCode || e.which;
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
    },
    handleChange(onChange) {
      if (onChange) {
        onChange();
      }
    },
    isDynamicSelectDisabled(column) {
      const supplierColumn = this.columns[column.supplierColumnIndex]
      return !supplierColumn || supplierColumn.value === null || supplierColumn.value === undefined || supplierColumn.value === ''
    },
    getDynamicSelectItems(column) {
      if (this.isDynamicSelectDisabled(column)) return []

      return column.options
        .filter(opt => this.columns[column.supplierColumnIndex].value == opt.id)
        .map(opt => opt.option)
    },
    showDynamicSelectDisabledMessage(column) {
      this.$set(this.dynamicSelectDisabledMessages, column.name, true)
    },
  }
}
</script>
<style scoped>
.margin-bottom {
  margin-bottom: 10px;
}

.dynamic-select-wrapper {
  position: relative;
}

.dynamic-select-disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  border: 0;
  background: transparent;
  cursor: not-allowed;
  z-index: 2;
}

.dynamic-select-disabled-message {
  color: #ff5252;
  font-size: 12px;
  margin-top: 4px;
}

.dynamic-select-enabled-message {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  margin-top: 4px;
}
</style>
